/**
 * @FileDescription: 系统-用户
 * @Author: fanqixin
 * @Date: 2021-6-23 10:37:49
 * @LastEditors: fanqixin
 * @LastEditTime: 2021-6-23 10:37:49
 */
import axios from "../base/axios.js";

const UserApi = {
	/**
	 * @description: 基础地址
	 */
	baseUrl: function() {
		return '/longstron/system/users';
	},
	/**
	 * @description: 忘记密码
	 * @param {Object} data 密码信息
	 */
	forgetPassword: function(data) {
		return axios.post(this.baseUrl() + '/forget/password', data);
	},
  /**
	 * @description: 认证列表
	 */
	authentication: function() {
		return axios.get(this.baseUrl() + '/my/authentication');
	},
  /**
	 * @description: 修改密码
	 * @param {Object} data 密码信息
	 */
	changePassword: function(data) {
		return axios.post(this.baseUrl() + '/change/password', data);
	},
};

export default UserApi;
